<template>
  <div style="display: flex; align-items: center; justify-content: start;">
    <p>icons used from: </p>
    <a href="https://icons8.com/" target="_blank" rel="noopener noreferrer" style="color: white;">icons8</a>
  </div>
  <br>
  <p>this page was made by: myself</p>
</template>
